// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import * as SagaBase from '../../../SagaBase';
import { QueryPart } from '../../../SagaBase/Objects/QueryPart';
import { Guid, GuidTools } from '@models/guid';

export abstract class QueryCondition_abstract extends QueryPart {
  static $t: string = 'SagaBase.Objects.QueryCondition';
  $t: string = 'SagaBase.Objects.QueryCondition';

  public static GetMembers(): string[] {
    return ['Operator', 'FieldType', 'Operands', 'SearchNull'].concat(QueryPart.GetMembers());
  }

  public GetMembers(): string[] {
    return QueryCondition_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Operator: SagaBase.Objects.OperatorType = SagaBase.Objects.OperatorType.isnull;
  public FieldType: SagaBase.Objects.ValueType = SagaBase.Objects.ValueType.undefined;
  public Operands: any[];
  public SearchNull: boolean = false;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
